import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import { CubaAppProvider } from "@cuba-platform/react";
import { HashRouter, Route } from "react-router-dom";
import "antd/dist/antd.min.css";
import "@cuba-platform/react/dist/index.min.css";
import "./output.css";
import { antdLocaleMapping, messagesMapping } from "./i18n/i18nMappings";
import "moment/locale/ru";
import { Provider } from "mobx-react";
import { cubaREST, rootStore } from "./app/store";
import { QueryClient, QueryClientProvider } from "react-query";

export const queryClient = new QueryClient();

ReactDOM.render(
  <Provider rootStore={rootStore}>
    <QueryClientProvider client={queryClient}>
      <CubaAppProvider
        cubaREST={cubaREST}
        messagesMapping={messagesMapping}
        antdLocaleMapping={antdLocaleMapping}
      >
        <HashRouter>
          <Route component={App} />
        </HashRouter>
      </CubaAppProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root") as HTMLElement,
);
